import React, { ComponentType } from 'react';
import { ControlProps } from '../../types/controlProps';
import { OwnPropsOfControl, OwnPropsOfEnum } from '@jsonforms/core';
import {
  withJsonFormsContext,
  JsonFormsStateContext,
  ctxToControlProps,
  ctxDispatchToControlProps,
  ctxToEnumControlProps,
  ctxToOneOfEnumControlProps,
} from '@jsonforms/react';

const withContextToControlProps = (Component: ComponentType<ControlProps>) =>
  function WithContextToControlProps({ ctx, props }: JsonFormsStateContext & ControlProps) {
    const controlProps = ctxToControlProps(ctx, props);
    const dispatchProps = ctxDispatchToControlProps(ctx.dispatch);
    return React.createElement(Component, { ...props, ...controlProps, ...dispatchProps });
  };

export const withJsonFormsControlProps = (
  Component: ComponentType<ControlProps>,
  memoize = true
): ComponentType<OwnPropsOfControl> =>
  withJsonFormsContext(withContextToControlProps(memoize ? React.memo(Component) : Component));

// ---- enum control props ----
const withContextToEnumProps = (Component: ComponentType<ControlProps & OwnPropsOfEnum>) =>
  function WithContextToEnumProps({ ctx, props }: JsonFormsStateContext & ControlProps & OwnPropsOfEnum) {
    const stateProps = ctxToEnumControlProps(ctx, props);
    const dispatchProps = ctxDispatchToControlProps(ctx.dispatch);

    return React.createElement(Component, { ...props, ...stateProps, ...dispatchProps });
  };

export const withJsonFormsEnumProps = (
  Component: ComponentType<ControlProps & OwnPropsOfEnum>,
  memoize = true
): ComponentType<OwnPropsOfControl & OwnPropsOfEnum> =>
  withJsonFormsContext(withContextToEnumProps(memoize ? React.memo(Component) : Component));

/// withJsonFormsOneOfEnumProps

const withContextToOneOfEnumProps = (Component: ComponentType<ControlProps & OwnPropsOfEnum>) =>
  function WithContextToOneOfEnumProps({ ctx, props }: JsonFormsStateContext & ControlProps & OwnPropsOfEnum) {
    const stateProps = ctxToOneOfEnumControlProps(ctx, props);
    const dispatchProps = ctxDispatchToControlProps(ctx.dispatch);
    return React.createElement(Component, { ...props, ...stateProps, ...dispatchProps });
  };

export const withJsonFormsOneOfEnumProps = (
  Component: ComponentType<ControlProps & OwnPropsOfEnum>,
  memoize = true
): ComponentType<OwnPropsOfControl & OwnPropsOfEnum> =>
  withJsonFormsContext(withContextToOneOfEnumProps(memoize ? React.memo(Component) : Component));
